import React, { useEffect, useRef, useState } from "react";
import { BsImage } from "react-icons/bs";
import { MdDeleteOutline } from "react-icons/md";
import CategoryService from "../../services/category.service";
import * as yup from "yup";
import useDialogState, { Loader } from "../../hook";
import { notifyError, notifySuccess } from "../../hook/notification";
import AddImageService from "../../services/addSingleImage.service";
import { useFormik } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NotificationService from "../../services/notification.service";
import CollectionService from "../../services/collection.service";

// Custom Dropdown component
const Dropdown = ({ options, onSelect, selectedValue }) => {
  const menuRef = useRef();
  const [toggleShow, setToggleShow] = useState(false);

  const userToggle = () => {
    setToggleShow((prev) => !prev);
  };

  const handleOutsideClick = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setToggleShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  return (
    <div className="flex flex-col gap-2 relative">
      <div onClick={userToggle} className="input cursor-pointer">
        {selectedValue === "" ? "Select" : selectedValue}
      </div>
      <div
        className={`${
          toggleShow ? "block" : "hidden"
        } bg-gray-800 rounded-6 overflow-hidden absolute top-[40px] w-full z-70 min-h-10 max-h-52 h-auto overflow-y-auto`}
      >
        {options.length > 0 ? (
          options.map((option, index) => (
            <p
              key={index}
              onClick={() => {
                onSelect(option.label, option.value);
                setToggleShow(false);
              }}
              className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white"
            >
              {option.label}
            </p>
          ))
        ) : (
          <p className="bg-transparent cursor-pointer hover:bg-gray-600 p-2 text-white">
            No data found
          </p>
        )}
      </div>
    </div>
  );
};

const AddImages = () => {
  const menuRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const hiddenFileInput = useRef(null);
  const [notification, setNotification] = useState(false);
  const [showVal, setShowVal] = useState("IMAGE");
  const [showVal2, setShowVal2] = useState("NON PREMIUM");
  const [showVal3, setShowVal3] = useState("");
  const [showVal4, setShowVal4] = useState("");
  const [fileName, setFileName] = useState("");
  console.log("🚀  AddImages  fileName:", fileName);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [collectionData, setCollectionData] = useState([]);

  const {
    loader: loader,
    handleClickOpen: setLoader,
    handleClose: unSetLoader,
  } = useDialogState();

  const toggle = () => {
    setOpen(!open);
  };

  const handleFile = (file) => {
    setFileName(file?.name);
  };
  const handleSelect = (value, id) => {
    formik.setFieldValue("multimediaType", id);
    setShowVal(value);
  };
  const handleSelect2 = (value, id) => {
    formik.setFieldValue("premium", id === "PREMIUM" ? true : false);
    setShowVal2(value);
  };
  const handleSelect3 = (value, id) => {
    formik.setFieldValue("categoryId", id);
    setShowVal3(value);
  };
  const handleSelect4 = (value, id) => {
    formik.setFieldValue("collectionId", id);
    setShowVal4(value);
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    formik.setFieldValue("categoryphoto", fileUploaded);
    handleFile(fileUploaded);
  };

  // Add Image Tag

  const [tagInput, setTagInput] = useState("");
  const [tags, setTags] = useState([]);

  const handleTagInputChange = (e) => {
    setTagInput(e.target.value);
  };

  const handleAddTag = () => {
    if (tagInput.trim() !== "") {
      if (tags === null || tags.length === 0) {
        setTags([tagInput.trim()]);
      } else {
        setTags([...tags, tagInput.trim()]);
      }
      setTagInput("");
    }
  };

  const getAllData = async () => {
    const response = await CategoryService.GetAllCategory(0, 0);
    const data = response.data.apiresponse.data;
    setData(data.categories);
  };

  const getAllCollectionData = async () => {
    const response = await CollectionService.GetAllCollection(0, 0);
    const data = response.data.apiresponse.data;
    setCollectionData(data?.collections);
  };

  useEffect(() => {
    getAllData();
    getAllCollectionData();
  }, []);

  const handleRemoveTag = (tagToRemove) => {
    const updatedTags = tags.filter((tag) => tag !== tagToRemove);
    setTags(updatedTags);
  };

  const CategoryOption = data.map((item) => {
    return {
      label: item.categoryName,
      value: item.id,
    };
  });

  const CollectionOption = collectionData.map((item) => {
    return {
      label: item.collectionName,
      value: item.id,
    };
  });

  const schema = yup.object().shape({
    imageName: yup.string().required("Please enter name"),
    categoryphoto:
      location.state === null && yup.string().required("Please select image"),
    premium: yup.boolean().required("Please select image type"),
    // categoryId: yup.string().required("Please select image category"),
  });

  const initialValue = {
    categoryId: "",
    categoryphoto: "",
    imageName: "",
    premium: false,
    tags: [],
    imageId: "",
    collectionId: "",
  };

  const submit = async (values, action) => {
    const {
      categoryId,
      imageName,
      imageId,
      categoryphoto,
      premium,
      collectionId,
    } = values;
    try {
      const emptyFile = new File([""], "empty.txt", { type: "text/plain" });
      const fileData = new FormData();
      fileData.append("categoryId", categoryId || 0);
      fileData.append("imageName", imageName);
      // if (categoryphoto !== "") {
      fileData.append("categoryphoto", categoryphoto || emptyFile);
      // }
      fileData.append("id", imageId);
      fileData.append("premium", premium);
      if (tags !== null) {
        fileData.append("tags", tags);
      }
      fileData.append("collectionId", collectionId || 0);
      fileData.append("sendNotification", notification);
      setLoader();

      await AddImageService.createImage(fileData);
      // if (notification) {
      //   await NotificationService.sendNotification(notification);
      // }
      notifySuccess(
        imageId ? "Update image successfully" : "Add image successfully"
      );
      setTimeout(() => {
        unSetLoader();
        navigate("/images");
        setFileName("");
        action.resetForm();
      }, 1500);
    } catch (error) {
      console.error("create error", error);
      notifyError("Something went wrong");
      setTimeout(() => {
        setFileName("");
        unSetLoader();
        navigate("/images");
        action.resetForm();
      }, 1500);
    }
  };

  const formik = useFormik({
    initialValues: initialValue,
    validationSchema: schema,
    onSubmit: submit,
  });

  const MultiMediaType = [
    { value: "IMAGE", label: "IMAGE" },
    { value: "VIDEO", label: "VIDEO" },
    { value: "GIF", label: "GIF" },
  ];

  const ImageType = [
    { value: "NON PREMIUM", label: "NON PREMIUM" },
    { value: "PREMIUM", label: "PREMIUM" },
  ];

  useEffect(() => {
    if (location.state !== null) {
      const data = location.state;
      formik.setFieldValue("categoryId", data.categoryId);
      formik.setFieldValue("imageId", data.imageId);
      formik.setFieldValue("premium", data.premium);
      formik.setFieldValue("imageName", data.imageName);
      formik.setFieldValue("collectionId", data.collectionId);
      setTags(data.tags);
      setFileName(data.url.split("/").pop().split("-").slice(1).join("-"));
      setShowVal2(data.isPremium === true ? "PREMIUM" : "NON PREMIUM");
      setShowVal(data.multimediaType);
      if (CategoryOption.length > 0) {
        const abcd = CategoryOption.find(
          (item) => item.value === data.categoryId
        );
        setShowVal3(abcd?.label || "");
      }
      if (CollectionOption.length > 0) {
        const abcd = CollectionOption.find(
          (item) => item.value === data.collectionId
        );
        setShowVal4(abcd?.label || "");
      }
    }
  }, [location, data]);

  const sendNotification = (e) => {
    setNotification(e.target.checked);
  };

  return (
    <>
      <div
        className="max-w-[900px] min-w-[300px] w-auto px-5 pb-10"
        ref={menuRef}
      >
        <div className="py-10">
          <div className="pb-5">
            <button onClick={toggle} className="btn save w-40">
              Add Tags
            </button>

            {open && (
              <div className="fixed inset-0 bg-[black]/60 z-[999] overflow-y-auto">
                <div
                  className="flex items-center justify-center min-h-screen px-4"
                  // onClick={() => setOpen(false)}
                >
                  <div className="bg-white overflow-hidden rounded-6 p-5 lg:p-7 max-w-[500px] w-full min-w-[350px]">
                    <h1 className="font-medium mb-5">Adding Title</h1>
                    <div className="flex flex-col gap-2 mb-7">
                      <label className="text-sm font-medium">Tag Title</label>
                      <input
                        className="bg-white w-full py-1.5 px-3 rounded-6 focus:outline-none border border-blue"
                        type="text"
                        placeholder="Enter Tag Name..."
                        value={tagInput}
                        onChange={handleTagInputChange}
                      />
                      <button
                        className="bg-blue w-full p-2 rounded-6 text-white font-medium"
                        onClick={handleAddTag}
                      >
                        Add Tag
                      </button>
                    </div>
                    {tags &&
                      tags.length > 0 &&
                      tags.map((tag, index) => (
                        <div key={index} className="border rounded-6 mb-1">
                          <div className="grid grid-cols-4 items-center border-b px-3 py-1.5">
                            <div className="col-span-3">
                              <span className="text-sm">{tag}</span>
                            </div>
                            <div className="col-span-1 flex justify-end border-l">
                              <button
                                className="bg-red/80 text-white text-sm font-medium rounded-6 py-1.5 px-2.5"
                                onClick={() => handleRemoveTag(tag)}
                              >
                                Remove
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    <div className="flex justify-end gap-4 items-center mt-7">
                      <button
                        onClick={() => (
                          setOpen(false), setTags([]), setTagInput("")
                        )}
                        className="border border-red/80 text-red/80 font-medium rounded-6 py-1.5 px-2.5 w-full"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() => setOpen(false)}
                        className="bg-blue text-white font-medium rounded-6 py-1.5 px-2.5 w-full"
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="my-3">
              {!open &&
                tags !== null &&
                tags.length > 0 &&
                tags.map((tag, index) => (
                  <div className="flex items-center justify-between text-white py-1.5 px-3 rounded-full border-blue border mb-1">
                    {tag}
                    <MdDeleteOutline
                      onClick={() => handleRemoveTag(tag)}
                      className="text-red text-2xl cursor-pointer"
                    />
                  </div>
                ))}
            </div>
          </div>
          <h1 className="text-base font-semibold leading-7 text-white">
            Add Image
          </h1>
          <p className="text-sm text-gray-500">
            Please Enter Image Information
          </p>
        </div>
        <form onSubmit={formik.handleSubmit}>
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Name</label>
            <input
              className="input"
              placeholder="Image name"
              name="imageName"
              value={formik.values.imageName}
              onChange={formik.handleChange}
              type="text"
            />
            {formik.errors.imageName && formik.touched.imageName && (
              <div className="text-red text-sm">{formik.errors.imageName}</div>
            )}
          </div>

          {/* Second Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Type</label>
            <Dropdown
              options={ImageType}
              onSelect={(value, id) => handleSelect2(value, id)}
              selectedValue={showVal2}
            />
            {console.log(formik.errors)}
            {formik.errors.premium && formik.touched.premium && (
              <div className="text-red text-sm">{formik.errors.premium}</div>
            )}
          </div>

          {/* Thrird Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Category</label>
            <Dropdown
              options={CategoryOption}
              onSelect={(value, id) => handleSelect3(value, id)}
              selectedValue={showVal3}
            />
            {formik.errors.categoryId && formik.touched.categoryId && (
              <div className="text-red text-sm">{formik.errors.categoryId}</div>
            )}
          </div>

          {/* Fourth Dropdown */}
          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Image Collection</label>
            <Dropdown
              options={CollectionOption}
              onSelect={(value, id) => handleSelect4(value, id)}
              selectedValue={showVal4}
            />
            {formik.errors.collectionId && formik.touched.collectionId && (
              <div className="text-red text-sm">
                {formik.errors.collectionId}
              </div>
            )}
          </div>

          <div className="flex flex-col gap-2 mb-7">
            <label className="label">Preview Image</label>
            <div className="flex items-center gap-5">
              <input type="image" accept="image/*" id="upload" hidden />
              <label
                onClick={handleClick}
                className="border border-white rounded-6 flex items-center justify-center flex-col gap-5 p-4 cursor-pointer w-full lg:p-10 text-center"
              >
                <BsImage className="text-gray-600 text-5xl" />
                <span className="text-white text-sm  ">
                  {!fileName ? (
                    <>
                      <span className="text-center">
                        <strong>Upload a file</strong> or drag and drop <br />
                        PNG, JPG, GIF
                      </span>
                    </>
                  ) : (
                    fileName
                  )}
                </span>
              </label>
              <input
                type="file"
                accept="image/*"
                onChange={handleChange}
                ref={hiddenFileInput}
                className="hidden"
              />
            </div>
            {formik.errors.categoryphoto && formik.touched.categoryphoto && (
              <div className="text-red text-sm mb-4">
                {formik.errors.categoryphoto}
              </div>
            )}
          </div>
          <div className="flex items-center">
            <input
              type="checkbox"
              id="notificaiton"
              className="p-3"
              onChange={sendNotification}
            />
            <label
              htmlFor="notificaiton"
              className="text-white ps-4 cursor-pointer"
            >
              Send Notification
            </label>
          </div>
          <div className="flex justify-end gap-4 items-center">
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn cancel"
            >
              Cancel
            </button>
            <button type="submit" className="btn save">
              {loader ? <Loader /> : "Save"}
            </button>
          </div>
        </form>
        <ToastContainer autoClose={1500} />
      </div>
    </>
  );
};

export default AddImages;
